import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { toggleModal } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { EmptyPage } from 'apps/auth/components/common/Layout/EmptyPage/EmptyPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import AccountStatementMain from 'apps/auth/components/ga/accounts/activity/statement/AccountStatementMain';
import HistorySpinner from 'apps/auth/components/history/HistorySpinner';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { AUTH_GA_ACCOUNT_HISTORY_PDF, AUTH_GA_CARD_HISTORY_PDF } from 'apps/auth/constants/UrlConstants';
import { fetchData } from 'apps/auth/helpers/api';

import ActivityItem, { ActivityItemSubheader } from './ActivityItem';
import ActivityDetailsModal from './modals/ActivityDetailsModal';

export const List = styled.ul`
    li:first-child {
        ${ActivityItemSubheader} {
            margin-top: 0;
        }
    }
`;

const loadData = (setLoading, fetchUrl, offset, history, updateExtra) => {
    setLoading(true);
    fetchData(fetchUrl + `?offset=${offset}`, 'POST').then((json) => {
        if (json.extra) {
            const newHistory = [...history];
            json.extra.history.forEach((h) => {
                newHistory.push(h);
            });
            updateExtra('history', newHistory);
            updateExtra('offset', newHistory.length);
            updateExtra('hasMore', json.extra.hasMore);
        }
        setLoading(false);
    });
};

const ActivityList = ({ showStatement = true, cardStatement = false, ...props }) => {
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (props.showLibrePayId && props.history?.length > 0) {
            props.history.map((item) => {
                const librePayId = item.payId;
                const stsId = item.mobileInfo?.stsId;
                const failedCheque = stsId > STATUS_OK;
                const textColor = failedCheque ? 'lightGray' : 'primary';
                const titleColor = failedCheque ? 'lightGray' : 'secondary';
                const options = {
                    titleColor,
                    failedCheque,
                    textColor,
                    stsId,
                };
                if (librePayId === Number(props.showLibrePayId)) {
                    props.toggleModal(true, <ActivityDetailsModal pocketId={props.pocketId} item={item} options={options} />, false);
                }
            });
        }
    }, []);

    useEffect(() => {
        const detectScrollToFooter = () => {
            const loadHeight = document.body.scrollHeight - document.documentElement.clientHeight - 300;
            if (!isLoading && loadHeight < window.scrollY && window.scrollY !== 0 && props.hasMore) {
                loadData(setLoading, props.fetchUrl, props.offset, props.history, props.updateExtraByName);
            }
        };
        document.addEventListener('scroll', detectScrollToFooter);
        return () => {
            document.removeEventListener('scroll', detectScrollToFooter);
        };
    }, [isLoading, props.fetchUrl, props.offset, props.hasMore]);

    const getHistory = (history) => {
        let isShowDate = true;
        let lastDate = null;
        if (history?.length > 0) {
            return history.map((item, index) => {
                if (lastDate) {
                    const lDate = new Date(lastDate);
                    const cDate = new Date(item.payTs);
                    isShowDate = lDate.getFullYear() !== cDate.getFullYear() || lDate.getMonth() !== cDate.getMonth() || lDate.getDay() !== cDate.getDay();
                }
                lastDate = item.payTs;
                return <ActivityItem key={`${index}${item.id}`} date={item.payTs} isShowDate={isShowDate} item={item} />;
            });
        }
    };

    const renderFullHistory = (
        <>
            <HeaderPanel
                title={props.historyTitle}
                buttonRowCaption={showStatement ? props.getStatementLink : ''}
                buttonRowOnClick={() => {
                    props.toggleModal(
                        true,
                        <AccountStatementMain
                            pdfUrl={cardStatement ? AUTH_GA_CARD_HISTORY_PDF : AUTH_GA_ACCOUNT_HISTORY_PDF}
                            idForUrl={cardStatement ? props.cardId : props.pocketId}
                        />,
                        false,
                    );
                }}
            />
            <List>{getHistory(props.history)}</List>
        </>
    );
    const renderEmptyHistory = (
        <>
            <HeaderPanel title={props.historyTitle} />
            <EmptyPage iconName="list-marked" emptyText={props.noTransactions} />
        </>
    );
    return (
        <>
            {props.history?.length > 0 ? renderFullHistory : renderEmptyHistory}
            {isLoading && <HistorySpinner forceShow />}
        </>
    );
};

const mapSateToProps = (state) => {
    return {
        pocketId: state.extra.pocket?.id,
        cardId: state.extra.card?.id,
        pocket: state.extra.pocket,
        offset: state.extra.offset,
        history: state.extra.history,
        hasMore: state.extra.hasMore,
        showLibrePayId: state.extra.showLibrePayId,
        noTransactions: state.messages.pageMessages.noTransactions,
        getStatementLink: state.messages.pageMessages.getStatementLink,
    };
};

export default connect(mapSateToProps, { updateExtraByName, toggleModal })(ActivityList);
